
export const formFiles = (): void => {
  const contactFormElement = document.querySelector('.js-contactForm') as HTMLElement

  if (!contactFormElement) {
    return
  }

  const allFileIInputs = contactFormElement.querySelectorAll('.js-contactForm-inputFileWrapper') as unknown as HTMLElement[]

  allFileIInputs.forEach((inputFileWrapper: HTMLElement) => {
    const inputTrigger = inputFileWrapper.querySelector('.js-contactForm-submitButton') as unknown as HTMLInputElement

    const hiddenFileInput = inputFileWrapper.querySelector('input[type="file"]') as unknown as HTMLInputElement

    inputTrigger.addEventListener('focus', (event: Event) => {
      event.preventDefault()
      inputTrigger.blur()
      hiddenFileInput.click()
    }
    )
    hiddenFileInput.addEventListener('change', (event: Event) => {
      inputTrigger.value = hiddenFileInput.value.replace(/C:\\fakepath\\/i, '')
    })
  })
}
